const loginUiTexts = {
	admin: {
		da: 'Administrator',
		en: 'Administrator',
	},
	email: {
		da: 'e-mail',
		en: 'e-mail',
	},
	password: {
		da: 'password',
		en: 'password',
	},
	login: {
		da: 'Log ind',
		en: 'Log in',
	},
	logout: {
		da: 'Log ud',
		en: 'Log out',
	}
};

module.exports = {
	loginUiTexts
};